import actions from './actions.js';
import mutations from './mutations.js';
import getters from './getters.js';

export default () => ({
	state: {
		app: null,
		error: null,
		theme: null,
		page: null,
		url: null,
		account: null,
		customer: null,
		payment: null,
		form: null,
		order: null,
		provider: null,
		providerAccount: null,
		localization: null,
		isCompany: false,
		isEmpty: true,
		isLoading: false,
		isNewMethod: false,
		isNewCart: true,
		terms: {
			checkbox: false,
			accepted: false,
			seen: false
		},
		retargetingUrl: '',
		selectedPayment: {},
		shouldGetOffer: false,
		connectionIsOnline: true,
		modal: '',
		polyfills: {},
		meta: {
			title: '',
			link: {},
			script: {},
			noscript: {}
		},
		zipCodeState: 'done',
		paymentGatewayProviderUrl: ''
	},
	actions,
	mutations,
	getters
});
